import './shared';

import 'owl.carousel/dist/owl.carousel.min';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import 'lightgallery/dist/js/lightgallery-all';
import 'lightgallery/modules/lg-fullscreen';
import 'lightgallery/modules/lg-video';
import 'lightgallery/dist/css/lightgallery.css';
import 'lightgallery/dist/css/lg-transitions.css';
import 'lightgallery/dist/css/lg-fb-comment-box.css';

import 'intersection-observer';

import '../styles/home_index.css'

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

((
    ($) => {
        $(document).ready(function () {
           function statisticsCounter() {
                let targets = $('.statistics');

                if (targets.length) {
                    let options = {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0.5
                    };

                    let observer = new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                if (!$(entry.target).hasClass('activated')) {
                                    $(entry.target).addClass('activated');
                                    if ($(entry.target).hasClass('statistics')) {
                                        const counts = $(entry.target).find('.count');
                                        counts.each(count => {
                                            $(counts[count]).prop('Counter', 0).animate({
                                                Counter: $(counts[count]).text()
                                            }, {
                                                duration: 2500,
                                                easing: 'swing',
                                                step: (now) => {
                                                    $(counts[count]).text(Math.ceil(now));
                                                }
                                            });
                                        });
                                    }
                                }
                            }
                        });
                    }, options);

                    targets.each(target => {
                        observer.observe(targets[target]);
                    });
                }
            }

            function owlCarousel() {

                const mainSlider = $(".main-slider");

                mainSlider.owlCarousel({
                    rtl: _isRtl,
                    margin: 0,
                    items: 1,
                    lazyLoad: true,
                    autoplay: true,
                    loop: true,
                    autoplayTimeout: 3000,
                    navText: ["<i class='icon-arrow-left'></i>", "<i class='icon-arrow-right'></i>"],
                    autoplayHoverPause: true,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    onInitialized: arrowsPos,
                    onResized: arrowsPos,
                    responsive: {
                        0: {
                            nav: false,
                            dots: false,
                        },
                        768: {
                            nav: true,
                            dots: true,
                        }
                    },
                });

                function arrowsPos(event) {
                    const element = event.target;
                    const item = event.item.index;
                    const prev = $(element).find('.owl-prev');
                    const next = $(element).find('.owl-next');
                    const image = $(element).find('.item1-image').eq(item);
                    const leftPos = parseInt(image.offset().left) - parseInt($(element).offset().left) + 10;
                    const rightPos = leftPos + parseInt(image.css('width')) - parseInt((prev.css('width'))) - 15 - 10;
                    prev.css('left', leftPos);
                    next.css('left', rightPos);
                }

                $('.success-slider').owlCarousel({
                    rtl: _isRtl,
                    margin: 0,
                    nav: true,
                    items: 1,
                    dots: false,
                    lazyLoad: true,
                    autoplay: true,
                    loop: true,
                    autoplayTimeout: 3000,
                    navText: ["<i class='icon-arrow-left'></i>", "<i class='icon-arrow-right'></i>"],
                    autoplayHoverPause: true,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    onInitialized: successArrowsPos,
                    onResized: successArrowsPos,
                });

                function successArrowsPos(event) {
                    const element = event.target;
                    const index = event.item.index;
                    const prev = $(element).find('.owl-prev');
                    const next = $(element).find('.owl-next');
                    const item = $(element).find('.item7').eq(index);
                    const leftPos = parseInt(item.offset().left) - parseInt($(element).offset().left) - parseInt(item.css('margin'));
                    const rightPos = leftPos + parseInt(item.css('width')) - parseInt((prev.css('width'))) + parseInt(item.css('margin'));
                    prev.css('left', leftPos);
                    next.css('left', rightPos);
                }

                $('.sponsor-slider').owlCarousel({
                    rtl: _isRtl,
                    margin: 0,
                    nav: false,
                    dots: true,
                    lazyLoad: true,
                    autoplay: true,
                    loop: true,
                    autoplayTimeout: 3000,
                    onInitialized: fitHeight,
                    onResized: fitHeight,
                    responsive: {
                        0: {
                            items: 2,
                        },
                        450: {
                            items: 3,
                        },
                        576: {
                            items: 4,
                        }, 768: {
                            items: 5,
                        },
                        991: {
                            items: 6,
                        },
                        1100: {
                            items: 7,
                        }
                    }
                });

                function fitHeight(event) {
                    const element = event.target;
                    const item = $(element).find('.item8');
                    item.css('height', item.css('width'));
                }
            }

            function lightGallery() {
                $('.video-block-wrapper').lightGallery({
                    selector: '.video-block',
                    thumbnail: false,
                    loop: false,
                    controls: false,
                    enableDrag: false,
                    counter: false,
                    autoplayControls: false,
                    actualSize: false,
                    useLeft: _isRtl,
                });
            }

            function itemsCoordinates() {
                if ($(window).innerWidth() > 767) {
                    $('.item4-content').each(function () {
                        $(this).css('height', $(this).parent().find('.item4-image').css('height'));
                    });
                } else {
                    $('.item4-content').each(function () {
                        $(this).css('height', 'unset');
                    });
                }
            }

            owlCarousel();
            lightGallery();
            itemsCoordinates();
            statisticsCounter();

            $(window).on('resize', function () {
                itemsCoordinates();
            });

        });

    }
)
(jQuery));
